import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Navigation from './../../Home/Navigation/Navigation';
import './Details.css';
import bg from '../../Assets/bghero.png'
import { Button } from 'react-bootstrap';

const Details = () => {
  const [project, setProject] = useState({});
  const { projectId } = useParams();

  useEffect(() => {
    fetch(`https://api.npoint.io/16c9e4824bc263427cec/${projectId-1}`)
      .then((res) => res.json())
      .then((data) => setProject(data));
  }, [projectId]);

  return (
      <div className="herobg" style={{ background: `url(${bg})`, backgroundAttachment: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
          <Navigation />
          <hr className="text-center text-white w-75 mx-auto mt-5" />
          <h1 className="project-title text center mb-1"><b>{project?.name}</b></h1>
          <Button className="me-3 py-1 px-3 rounded-pill btn btn-warning" href={project?.live} target="_blank">Live Link</Button>
          <Button className="me-3 py-1 px-3 rounded-pill btn btn-info" href={project?.git1} target="_blank">Client Side Code Link</Button>
          {project?.git2 && <Button className="me-3 py-1 px-3 rounded-pill btn btn-info" href={project?.git2} target="_blank">Server Side Code Link</Button>}
         <br />
          <img className="text-center w-75 mx-auto txbg my-4" src={project?.ftimg} alt="" />
          <br />
          <p className="text-center  w-100 text-white txbg ">{project?.description} {project?.details1}</p>
          <img className="text-center w-75 mx-auto txbg " src={project?.img1} alt="" />
          <p className="text-center  w-100 text-white txbg "> {project?.details2}</p>
          <img className="text-center w-75 mx-auto txbg " src={project?.img2} alt="" />
          <p className="text-center  w-100 text-white txbg "> {project?.details3}</p>
          <img className="text-center w-75 mx-auto txbg " src={project?.img3} alt="" />
          <p className="text-center  w-100 text-white txbg "> Technology used: {project?.Technology}</p>
          <br />
    </div>
  );
};

export default Details;